import { i18n } from '@/commons/config/i18n';
import { ApiErrorRecord, BFFApiErrorRecord, Nullable } from '@/commons/models';
import { isJSONString } from '@/commons/utils/strings';
import { TranslateResult } from 'vue-i18n';

export default class ApiError<R> {
  errorCode: number;
  message: string;
  translationKey: string;

  constructor(errorRecord?: ApiErrorRecord | BFFApiErrorRecord<R>) {
    const defaultErrorRecord = { status: 0, data: null, translationKey: null };
    const { status, data, translationKey } = errorRecord ?? defaultErrorRecord;
    this.errorCode = status;
    const dataResponse = data && this.getDataResponse(data);
    const exceptionMessage = this.checkDataResponse(dataResponse);
    this.message = exceptionMessage ?? '';
    this.printLog();
    this.translationKey = translationKey ?? 'error.generic';
  }

  private getDataResponse(data: Nullable<Record<string, any>>) {
    return data;
  }

  private checkDataResponse(dataResponse: Nullable<Record<string, any>>) {
    return (
      dataResponse?.content?.exceptionMessage ??
      dataResponse?.code ??
      dataResponse?.exceptionMessage
    );
  }

  getMessage() {
    if (!i18n.te(this.translationKey)) return this.message;

    return i18n.t(this.translationKey);
  }

  getExceptionMessage(): TranslateResult {
    const errorRecord = isJSONString(this.message) ? JSON.parse(this.message) : this.message;
    const message =
      errorRecord?.key && i18n.te(errorRecord.key)
        ? i18n.t(errorRecord.key)
        : i18n.t(this.translationKey);

    return message;
  }

  private printLog() {
    if (this.message) {
      console.error(this.message);
    }
  }
}

export function resolveApiErrorMessage(error: unknown, fallbackKey: string, values?: Object): string {
  if (error instanceof ApiError && i18n.te(error.translationKey)) {
    return i18n.t(error.translationKey, values) as string;
  }

  return i18n.t(fallbackKey, values) as string;
}
